import { createContext } from 'react';

const ProcessHandlingListContext = createContext({
  handlingList: {},
  destinationAddress: {},
  parcels: [],
  setParcels: () => {},
  currentParcel: null,
  setCurrentParcel: () => {},
  shouldAddToParcel: true,
});

export default ProcessHandlingListContext;
